import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Hero() {
  return <header className="relative w-full overflow-hidden border-b border-zinc-800 bg-zinc-950" data-id="element-56" data-mp="ehtjpxlbn3oc">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-6 py-16 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:py-24" data-id="element-57" data-mp="9ipbpaa4vbzl">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-58" data-mp="129h0hmovcycw">
          <p className="mb-5 text-sm font-semibold text-amber-400" data-id="element-59" data-mp="x8bcg265lz9p">
            Para profes de boxeo que quieren dejar de zafar clase a clase
          </p>
          <h1 className="font-display text-4xl uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl" data-id="element-60" data-mp="nb6mdr96tjnm">
            Dejá de improvisar y empezá a formar boxeadores de verdad{' '}
            <span className="align-middle" data-id="element-61" data-mp="3825ywscu0bmf">🥊</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-zinc-300" data-id="element-62" data-mp="384s2yi0ik8zw">
            El sistema completo para profes de boxeo que buscan{' '}
            <strong className="font-semibold text-white" data-id="element-63" data-mp="3o6kdjcmbi22h">planificar clases profesionales</strong>,
            corregir técnica con fundamentos y llenar su gimnasio con alumnos que no abandonan.
          </p>

          <div className="mt-9 flex flex-col items-start gap-3" data-id="element-64" data-mp="3e84mf9naissz">
            <CtaButton origin="hero" data-id="element-65" data-mp="30hhnphhj52ww">Quiero el pack Boxeo 360 ahora</CtaButton>
            <Countdown data-id="element-66" data-mp="358reiletecad" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative" data-id="element-67" data-mp="35aat87ktofa1">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/e81a9e74-6ecf-454c-a4dd-3d9addba3252.jpg" alt="Los 6 tomos del pack Boxeo 360 junto a los bonos digitales en un gimnasio de boxeo" className="w-full rounded-lg shadow-2xl shadow-black/80 ring-1 ring-zinc-800" data-id="element-68" data-mp="2hj5e5umphr0s" />
          <p className="absolute -bottom-4 left-4 rounded-md bg-amber-400 px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-zinc-950 shadow-xl" data-id="element-69" data-mp="nb1j0zx5pjub">
            6 tomos + 5 bonos
          </p>
        </motion.div>
      </div>
    </header>;
}